import {API_BASE, authHeaders} from './shared';

/** A failed call to the agent API; `status` tells "someone else took it" (409) from "log in again" (401). */
export class AgentApiError extends Error {
  constructor(message, status) {
    super(message);
    this.status = status;
  }
}

export const AGENT_SESSION_EXPIRED = 'ogm:agent-session-expired';

async function call(path, {method = 'GET', body, keepalive} = {}) {
  let res;
  try {
    res = await fetch(`${API_BASE}/api${path}`, {
      method, keepalive, headers: authHeaders(), body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch {
    throw new AgentApiError("Can't reach the server. Check your connection.", 0);
  }
  if (res.status === 204) return null;
  let data = null;
  try { data = await res.json(); } catch { /* empty body */ }
  if (!res.ok) {
    if (res.status === 401) window.dispatchEvent(new Event(AGENT_SESSION_EXPIRED));
    throw new AgentApiError((data && (data.error || data.detail)) || `Request failed (${res.status})`, res.status);
  }
  return data;
}

export const agentApi = {
  login: (email, password) => call('/agent/login', {method: 'POST', body: {email, password}}),
  profile: () => call('/agent/profile'),
  stats: () => call('/agent/stats'),

  presence: () => call('/agent/availability'),
  setPresence: (online, busy, opts = {}) => call('/agent/availability', {method: 'PUT', body: {online, busy}, ...opts}),
  heartbeat: () => call('/agent/heartbeat', {method: 'POST'}),

  waiting: () => call('/agent/waiting'),
  accept: (requestId) => call('/agent/calls/accept', {method: 'POST', body: {requestId}}),
  end: (sessionId, opts = {}) => call(`/agent/calls/${sessionId}/end`, {method: 'POST', ...opts}),

  missed: () => call('/agent/missed'),
  followedUp: (requestId, note) => call(`/agent/missed/${requestId}/followed-up`, {method: 'POST', body: {note: note || null}}),

  upcoming: () => call('/agent/upcoming'),
  claim: (callId) => call(`/agent/upcoming/${callId}/claim`, {method: 'PUT'}),
  startBooked: (callId) => call(`/agent/upcoming/${callId}/start`, {method: 'POST'}),
  cancel: (callId) => call(`/agent/upcoming/${callId}/cancel`, {method: 'PUT'}),
  complete: (callId) => call(`/agent/upcoming/${callId}/complete`, {method: 'PUT'}),
};
